import { FC } from 'react';
import Chart from '../chart';

interface IRenderTeamRoomSnapProps {
	data: any;
	activeTab: string;
}

const RenderTeamRoomSnap: FC<IRenderTeamRoomSnapProps> = ({
	data,
	activeTab,
}) => {
	return (
		<>
			{data.map((chart: any, i: number) => {
				const item = chart.responsePayload;
				return (Array.isArray(item) ? item?.length : item?.itemsList.length) ? (
					<Chart
						key={i + chart.capturedInput}
						item={chart}
						originalName={chart}
						activeTab={activeTab}
					/>
				) : null;
			})}
		</>
	);
};

export default RenderTeamRoomSnap;
